module.exports = __webpack_public_path__ + "static/media/banner.234e1039.jpg";